import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  header : HttpHeaders;
  readonly urlBase =  environment.rutaBase; 
  constructor( private http: HttpClient, private accesoService: AccesoService) { 
    this.header = this.accesoService.desencriptarTOKEN();
  }

  ObtenerListarArea(FechaInicio: any, FechaFinal: any)
  {
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/Reporte/Area?AreaPadre=1`,{headers});
  }

  ObtenerListarMeta(){
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/Reporte/Meta`,{headers});
  }

}
